import type { RenderableTreeNode, RenderableTreeNodes } from "@ext/markdown/core/render/logic/Markdoc";
// Импорт значением из `Markdoc/index.ts` тянет весь markdown-it и не поддаётся tree-shaking'у
// (побочный эффект `new Tokenizer(...)` на верхнем уровне модуля); `src/ast/tag` импортирует только тип.
import MarkdocTag from "@ext/markdown/core/render/logic/Markdoc/src/ast/tag";
import { CITATION_PLACEHOLDER_REGEX } from "@ext/serach/types";

const superscriptDigits = "⁰¹²³⁴⁵⁶⁷⁸⁹";
const toSuperscript = (n: number): string =>
	String(n)
		.split("")
		.map((d) => superscriptDigits[Number(d)])
		.join("");

/** Проверка структурная: дерево приходит и разобранным из JSON, где класс уже потерян. */
const isMarkdocTag = (node: unknown): node is MarkdocTag =>
	!!node && typeof node === "object" && (node as MarkdocTag).$$mdtype === "Tag";

const chatCitations = (root: RenderableTreeNodes): RenderableTreeNodes => {
	const transformNode = (node: RenderableTreeNodes): RenderableTreeNodes => {
		if (Array.isArray(node)) {
			return node.flatMap((child) => transformNode(child)) as RenderableTreeNodes;
		}

		if (typeof node === "string") {
			CITATION_PLACEHOLDER_REGEX.lastIndex = 0;

			const result: RenderableTreeNode[] = [];
			let lastIndex = 0;

			for (
				let match = CITATION_PLACEHOLDER_REGEX.exec(node);
				match !== null;
				match = CITATION_PLACEHOLDER_REGEX.exec(node)
			) {
				const [full, indexStr, rawLogicPath, relativePath] = match;
				const index = Number(indexStr);
				const logicPath = rawLogicPath.replace(/[\u200B\u2060]/g, "");
				const href = `/${logicPath}`;
				if (match.index > lastIndex) {
					result.push(node.slice(lastIndex, match.index));
				}
				result.push(
					new MarkdocTag(
						"ChatLink",
						{
							index,
							href,
							resourcePath: relativePath,
						},
						[`${toSuperscript(index)}↗`],
					),
				);
				lastIndex = match.index + full.length;
			}

			if (lastIndex === 0) return node;

			if (lastIndex < node.length) {
				result.push(node.slice(lastIndex));
			}

			return result;
		}

		if (isMarkdocTag(node)) {
			const children = (node.children ?? []).flatMap((ch) => transformNode(ch)) as RenderableTreeNode[];
			return new MarkdocTag(node.name, node.attributes, children);
		}

		return node;
	};

	return transformNode(root);
};

export default chatCitations;
